import type { Coding } from "@medplum/fhirtypes";
import { useNlmSearch } from "@/shared/hooks/use-nlm-search";

/**
 * Human Phenotype Ontology (HPO) — a FHIR-recognized ontology for phenotypic
 * features. Used here as the symptom code system. Codes look like `HP:0002315`
 * (Headache). Migration path: when Medplum's terminology service is loaded
 * with SNOMED CT, swap the URL + system constant; storage shape on
 * Observation.code / Condition.evidence.code stays the same.
 */
const HPO_URL = "http://human-phenotype-ontology.org";
const NLM_API = "https://clinicaltables.nlm.nih.gov/api/hpo/v3/search";

export interface HpoCodeOption {
  code: string;
  display: string;
  system: string;
  coding: Coding;
}

const searchConfig = {
  endpoint: NLM_API,
  params: "",
  parse(data: [number, string[], null, [string, string][]]): HpoCodeOption[] {
    const entries = data[3] ?? [];
    return entries.map(([code, display]) => ({
      code,
      display,
      system: HPO_URL,
      coding: { system: HPO_URL, code, display },
    }));
  },
};

export function useHpoCodeSearch(query: string) {
  return useNlmSearch(query, searchConfig);
}
